import type { GameProfile, ProfileCtx } from "./types";
import FiveMProfile from "@/game_profiles/fiveM";
import { i18n } from "@/i18n";

const { t } = i18n.global;
const join = () => {
  window.open(t("ngp/settings/section/redm_wiki/link"), "_blank", "noopener,noreferrer");
};

export default (_ctx: ProfileCtx): Partial<GameProfile> => ({
  ...FiveMProfile(),
  join: {
    buttonTextKey: "ngp/settings/section/redm_wiki",
    joinFn: join,
  },
});
